import { IOption } from 'components/CardSelect/CardSelect';
import { TooltipConsignment } from './tooltipComponent';
import { formatCurrencyInCents } from 'helpers';
import { IVinculoFuncionalSummary } from 'services/datasets';

export function summaryPortability(
    data:
        | {
              VinculoFuncionals: IVinculoFuncionalSummary[];
          }
        | undefined
): IOption[] {
    const vinculos = data?.VinculoFuncionals ?? [];
    const options: IOption[] = [];

    vinculos.forEach((vinculo: IVinculoFuncionalSummary, index) => {
        vinculo.Produtos?.forEach((produto) => {
            produto?.AutorizacaoPortabilidades?.forEach((aut) => {
                if (aut.Autorizado === 'S') {
                    const contrato = {
                        contrato: aut.ContratoPortado?.NrContrato ?? 'N/A',
                        nome: vinculo.NmOrgao,
                        valor: aut.VlMargemDisp ?? 0,
                        validade: aut.DtValidade ?? 'N/A',
                    };

                    options.push({
                        label: `Nr contrato: ${aut.ContratoPortado?.NrContrato ?? 'N/A'} - ${
                            vinculo.NmOrgao
                        }`,
                        description: `Matrícula: ${vinculo.CdMatricula} - Data Validade: ${
                            aut.DtValidade ?? 'N/A'
                        } - Margem: ${formatCurrencyInCents(aut.VlMargemDisp ?? 0)}`,
                        value: `${vinculo.CdMatricula}-${aut.ContratoPortado?.NrContrato}`,
                        disabled: false,
                        tooltipComponent: {
                            title: (
                                <TooltipConsignment
                                    values={{
                                        CodOrgao: vinculo.CodOrgao,
                                        NmOrgao: vinculo.NmOrgao,
                                        CnpjOrgao: vinculo.CnpjOrgao,
                                        DescTipoVinc: vinculo.DescTipoVinc ?? '',
                                        CodSituacaoFuncional: vinculo.CodSituacaoFuncional ?? '',
                                        DescSituacaoFuncional: vinculo.DescSituacaoFuncional ?? '',
                                        CdRubrica: produto.CdRubrica ?? '',
                                        DsRubrica: produto.DsRubrica ?? '',
                                        Contratos: [contrato],
                                        totalMargem: aut.VlMargemDisp ?? 0,
                                        DatasValidade: vinculo.DatasValidade ?? [],
                                        CdMatricula: vinculo.CdMatricula ?? '',
                                    }}
                                    currentIndex={index + 1}
                                />
                            ),
                            placement: 'left',
                            children: <></>,
                        },
                    });
                }
            });
        });
    });

    return options;
}

export function transformPurchaseContracts(
    checkPurchaseContracts:
        | {
              VinculoFuncionals: IVinculoFuncionalSummary[];
          }
        | undefined
) {
    return (
        checkPurchaseContracts?.VinculoFuncionals?.flatMap((item) => {
            const produto = item.Produtos[0] || {};
            const autorizacoes = (produto.AutorizacaoPortabilidades || []).filter(
                (aut) => aut.Autorizado === 'S'
            );

            return autorizacoes.map((autorizacao) => ({
                warrantyType: 'PublicPayroll',
                employeeCode: item.CdMatricula,
                agreementCode: produto.CdConvenio,
                governmentDepartmentCode: item.CodOrgao,
                employeerInstCode: item.OrgMatInst,
                paymentAmountInCents: autorizacao.VlMargemDisp || produto.VlMargemDisp || 0,
                employmentStatusCode: item.CodSituacaoFuncional,
                employmentStatusDescription: item.DescSituacaoFuncional,
                codOrgao: item.CodOrgao,
                codTipoVinc: item.CodTipoVinc,
                descTipoVinc: item.DescTipoVinc,
                nmOrgao: item.NmOrgao,
                cnpjOrgao: item.CnpjOrgao,
                codClassificacao: item.CodClassificacao,
                descClassificacao: item.DescClassificacao,
                cdUpag: item.CdUpag,
                cdUfUpag: item.CdUfUpag,
                bancoDomicBancario: item.BancoDomicBancario,
                agenciaDomicBancario: item.AgenciaDomicBancario,
                contaDomicBancario: item.ContaDomicBancario,
                codTipoPensao: item.CodTipoPensao,
                descTipoPensao: item.DescTipoPensao,
                validadePensao: item.ValidadePensao,
                autorizacaoEmprestimo: produto.AutorizacaoEmprestimo,
                autorizacaoCartao: produto.AutorizacaoCartao,
                autorizacaoDescSindical: produto.AutorizacaoDescSindical,
                autorizacaoDescMensal: produto.AutorizacaoDescMensal,
                autorizacaoCartaoBeneficio: produto.AutorizacaoCartaoBeneficio,
                contratoPortado: autorizacao.ContratoPortado,
                dtValidadePortabilidade: autorizacao.DtValidade,
            }));
        }) || []
    );
}
